/**
 * Case-insensitive subsequence match: returns true when every character of the
 * query appears in `text` in order (not necessarily contiguously). An empty query
 * matches everything. Used for lightweight fuzzy filtering of list panels.
 */
export function fuzzyMatch(query: string, text: string): boolean {
  const needle = query.trim().toLowerCase();
  if (needle === '') {
    return true;
  }
  const haystack = text.toLowerCase();
  let i = 0;
  for (const char of haystack) {
    if (char === needle[i]) {
      i++;
      if (i === needle.length) {
        return true;
      }
    }
  }
  return false;
}
